export default "__VITE_ASSET__C1j$zIzl__"